"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var DataTableColumnCellDirective = /** @class */ (function () {
    function DataTableColumnCellDirective(template) {
        this.template = template;
    }
    DataTableColumnCellDirective.decorators = [
        { type: core_1.Directive, args: [{ selector: '[ngx-datatable-cell-template]' },] },
    ];
    /** @nocollapse */
    DataTableColumnCellDirective.ctorParameters = function () { return [
        { type: core_1.TemplateRef, },
    ]; };
    return DataTableColumnCellDirective;
}());
exports.DataTableColumnCellDirective = DataTableColumnCellDirective;
//# sourceMappingURL=column-cell.directive.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/@swimlane/ngx-datatable/release/components/columns/column-cell.directive.js
// module id = GHh8
// module chunks = 4